import { Button, FullBox, Typography } from 'seagull';
import ExternalLinkButton from "../../components/ExternalLinkButton";
import styles from "./APIKeysEmptyState.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const APIKeysEmptyState = _ref => {
  let {
    generateKey
  } = _ref;
  return /*#__PURE__*/_jsxs(FullBox, {
    className: styles.emptyState,
    "data-testid": "api-keys-empty-state",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      weight: "normal",
      "data-testid": "api-keys-empty-state-title",
      children: "Connect Anchor with your tools using our open API"
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph1",
      skin: "secondary",
      "data-testid": "api-keys-empty-state-description",
      align: "center",
      style: {
        width: 800
      },
      children: ["Anchor's API lets you integrate your existing systems, automate workflows, and keep your data in sync. You can review the", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        href: "https://docs.sayanchor.com",
        underline: "none",
        openInNewTab: true,
        "data-testid": "api-keys-empty-state-api-docs-link",
        children: "API documentation"
      }), ' ', "to get started or explore use cases in our", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        href: "https://intercom.help/anchor-billing/en/articles/12293577-anchor-api-webhooks",
        underline: "none",
        openInNewTab: true,
        "data-testid": "api-keys-empty-state-knowledge-base-link",
        children: "knowledge base"
      }), ". When you're ready, generate your first API key below."]
    }), /*#__PURE__*/_jsx(Button, {
      onClick: generateKey,
      "data-testid": "api-keys-empty-state-generate-key-button",
      children: "Generate API key"
    })]
  });
};